<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header header_popup">
    <div [ngSwitch]="featureType">
      <span class="title" *ngSwitchCase="1">Annulation de la facture N° <strong>{{InvoiceNumber}}</strong></span>
      <span class="title" *ngSwitchCase="2">Renvoi pour complément de la facture N° <strong>{{InvoiceNumber}}</strong></span>
      <hr>
    </div>
  </mat-card-title>

  <mat-card-content class="container-content content">
    <form name="form" #f="ngForm" autocomplete="off">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
          <div fxFlex="30" fxFlex.gt-sm="30" *ngIf="hasMultipleTemplates" class="dropDownStyle">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Modèles d'emails : </mat-label>
              <input matInput hidden>
              <ng-multiselect-dropdown class="" [settings]="emailTemplateDropDownSettings" [data]="emailTemplates" placeholder="Sélectionner..." (onSelect)="onSelectTemplate($event)" ngDefaultControl>
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxFlex="70" fxFlex.gt-sm="70">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Envoyer à</mat-label>
              <input matInput name="Recipients" [(ngModel)]="recipients" pattern="^(\s*[^\s;]+@[^\s;]+\.[^\s;]+\s*;)*(\s*[^\s;]+@[^\s;]+\.[^\s,]*\s*;?)" required>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Objet</mat-label>
            <input matInput name="Title" [(ngModel)]="emailModel.Title" required>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start">
          <div fxFlex="97" fxFlex.gt-sm="97">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Email </mat-label>
              <input matInput hidden readonly>
              <div [hidden]="!editMode" class="mail-display-content jumbotron-edit">
                <app-rich-text-editor [content]="emailModel.Content" (onContentChanged)="onContentChanged($event)"></app-rich-text-editor>
              </div>
              <div [hidden]="editMode" class="jumbotron jumbotron-display overflow-auto">
                <div [innerHTML]="emailContentBeforeReasonsMarker"></div>
                <ul *ngIf="dynamicReasonsMarkerFound">
                  <li *ngFor="let rejectionReason of selectedEmailTemplate.RejectionReasons">
                    <mat-checkbox name="rejectionReason" [labelPosition]="'after'" (change)="onSelectRejectionReason($event, rejectionReason.Id)">
                      {{rejectionReason.Content}}
                    </mat-checkbox>
                  </li>
                </ul>
                <div [innerHTML]="emailContentAfterReasonsMarker"></div>
              </div>
            </mat-form-field>
          </div>
          <div fxFlex="3" fxFlex.gt-sm="3">
            <span class="material-icons edit-icon" (click)="onToggleEditMode(editMode);">
              edit
            </span>
          </div>
        </div>
        <div fxLayout="row" fxFlex="100">
          <div class="card-body" style="padding: 0;">
            <app-markers [dynamicPortalUrlMarkerIsMandatory]="dynamicPortalUrlMarkerIsMandatory" [dynamicAccessCodeMarkerIsMandatory]="dynamicAccessCodeMarkerIsMandatory"
              [dynamicReasonsMarker]="dynamicReasonsMarker" [dynamicPortalUrlMarker]="dynamicPortalUrlMarker" [dynamicAccessCodeMarker]="dynamicAccessCodeMarker"
              [dynamicReasonsMarkerFound]="dynamicReasonsMarkerFound" [dynamicPortalUrlMarkerFound]="dynamicPortalUrlMarkerFound" [dynamicAccessCodeMarkerFound]="dynamicAccessCodeMarkerFound">
            </app-markers>
          </div>
        </div>
      </div>
    </form>
    <div class="row box" *ngIf="showPickedWarning">
      <span class="material-icons bg-color-help">
        help
      </span>
      <strong>Attention :</strong>&nbsp;Cette facture est prise en charge par un autre utilisateur.
    </div>
  </mat-card-content>

  <hr>
  <mat-card-footer class="container-footer">
    <div class="modal-footer d-table w-100">
      <div class="d-table-cell">
        <button tabindex="-1" mat-stroked-button class="currentBtn" (click)="close(false);">Annuler</button>
      </div>
      <div class="d-table-cell tar">
        <button tabindex="-1" mat-stroked-button class="currentBtnColor" [disabled]="f.form.invalid || !AreMarkersValid" (click)="onSubmit()">Envoyer</button>
      </div>
    </div>
  </mat-card-footer>

</mat-card>